import ProfileAvatar from '@src/components/Molecules/ProfileAvatar';
import React from 'react';

type Props = {
  height: string;
  width: string;
  src: string;
  borderRadius?: string;
  /** 이미지가 없거나 깨졌을 때 보여줄 이니셜의 출처 */
  name?: string;
};

/**
 * 헤더 등에서 쓰는 사용자 프로필 아이콘.
 * 실제 렌더는 ProfileAvatar가 맡아 URL이 없거나 깨져도 이니셜 아바타로 대체된다.
 */
const CMUserProfile = ({ height, width, src, name }: Props) => {
  const size = parseInt(String(height), 10) || 40;
  return <ProfileAvatar url={src} name={name} size={size} />;
};

export default CMUserProfile;
